import React, { useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { useGetPaymentsHistory } from 'services/payments/payments/hooks/useGetPaymentsHistory';
import { useUserSubscriptionStore } from 'store/useUserSubscriptionStore';
import { getUserSubscription } from 'store/useUserSubscriptionStore/selectors';

import { PAYMENT_STATUS } from 'interfaces/payments';
import { SUBSCRIPTION_PLAN } from 'interfaces/subscriptions';

import { SectionTitle } from 'components/_basic/SectionTitle/SectionTitle';

import { PaymentHistory } from './components/PaymentHistory';
import { PaymentMethod } from './components/PaymentMethod';
import { getPaymentsHistory } from './helpers';

export const AccountPaymentInfoPage: React.FC = () => {
  const { t, i18n } = useTranslation();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handlePageChange = (page: number) => {
    setPage(page);
  };
  const handleRowsPerPageChange = (rowsPrePage: number) => {
    setRowsPerPage(rowsPrePage);
  };
  const currentSubscription = useUserSubscriptionStore(getUserSubscription);

  const { data, isLoading, error } = useGetPaymentsHistory({ page: page, size: rowsPerPage });
  const isFree = currentSubscription?.currentSubscription.subscriptionPlan === SUBSCRIPTION_PLAN.FREE;

  const payments = useMemo(() => getPaymentsHistory(i18n.language, data), [data, i18n.language]);
  const lastPayment = data?.content[0];
  const onlySuccessfullPayments = useMemo(
    () => payments.filter((payment) => payment.status === PAYMENT_STATUS.SUCCEEDED),
    [payments],
  );

  const showPaymentError = !isFree && !!lastPayment;

  return (
    <>
      <Helmet>
        <script type="text/javascript" defer>
          {`
            window.dataLayer = window.dataLayer || [];
            let userId = '';
            try {
              const userStore = localStorage.getItem('user-store');
              if (userStore) {
                const parsed = JSON.parse(userStore);
                userId = parsed?.state?.authUser?.id || '';
                dataLayer.push({ user_id: userId });
              }
            } catch (e) {
              console.error('Failed to parse user-store:', e);
            }
          `}
        </script>
        <script type="text/javascript" defer>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-M6DSFF7W');`}
        </script>
        <script type="text/javascript" defer>
          {`!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '951508482576405');
            fbq('track', 'PageView');`}
        </script>
      </Helmet>
      <SectionTitle title={t('paymentInfo')} />
      <PaymentMethod lastPayment={lastPayment} showFailAlert={showPaymentError} />
      <PaymentHistory
        payments={onlySuccessfullPayments}
        totalCount={onlySuccessfullPayments?.length}
        isLoading={isLoading}
        error={error}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </>
  );
};
